<template>
  <div class="appStore">
    <a class="appStore_icon" href="https://apps.apple.com/jp/app/id1574893406" target="_blank">
      <img :src="`${cdn}/img/top/icon_app_store.svg`" alt="App Storeからダウンロード">
    </a>
    <a class="appStore_icon" href="https://play.google.com/store/apps/details?id=jp.stockpoint.spm" target="_blank">
      <img :src="`${cdn}/img/top/icon_google_play.svg`" alt="Google Playで手に入れよう">
    </a>
  </div>
</template>

<style scoped>
.appStore {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.appStore_icon:not(:last-child) {
  margin-right: 20px;
}
</style>

<script>
export default {
  props:{
  },

  data: function() {
    return {
      cdn: CDN
    }
  },

  mounted: async function() {
  },

  methods: {
  },

  components: {
  }
}
</script>
